import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'mobx-react'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import IndexPage from './pages'
import ReactGA from 'react-ga4'

import './theme/chiliz.less'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

if (process.env.REACT_APP_TRACKING_ID !== undefined && process.env.REACT_APP_TRACKING_ID !== '') {
  ReactGA.initialize(process.env.REACT_APP_TRACKING_ID ?? '')
}

root.render(
    <React.StrictMode>
      <Provider>
        <BrowserRouter>
          <IndexPage/>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
)

const SendAnalytics = (): void => {
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(SendAnalytics)
